// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5c-6";
export var headerCell = "_5c-2";
export var rowWrapper = "_5c-4";
export var stickyAggregationCell = "_5c-a";
export var stickyAggregationRow = "_5c-7";
export var stickyColumnCell = "_5c-9";
export var stickyColumnHeaderCell = "_5c-8";
export var table = "_5c-1";
export var virtualRowWrapper = "_5c-5";
export var virtualTableContainer = "_5c-0";
export var white = "_5c-3";